import React from 'react';

import type { LayoutRendererProps } from '../types';

/**
 * One-column layout component
 * Renders a single element in a full-width column
 */
export const OneColumnLayout: React.MemoExoticComponent<
	(props: LayoutRendererProps) => React.JSX.Element | null
> = React.memo(
	(props: LayoutRendererProps): React.JSX.Element | null => {
		if (props.content.length < 1) {
			return null;
		}

		return props.renderElement({
			component: props.content[0],
			position: 'single-column',
			isFoldable: props.isFoldable,
		});
	},
	(prevProps, nextProps) => {
		return (
			prevProps.content === nextProps.content &&
			prevProps.isFoldable === nextProps.isFoldable &&
			prevProps.isStreaming === nextProps.isStreaming &&
			prevProps.subAgentDataMap === nextProps.subAgentDataMap
		);
	},
);
